import apiJaringan from '@/api/vo-general/jaringan';

const defaultState = () => ({
	genealogyList: [],
	sponsorData: {},
	sponsorList: [],
	sponsorPagination: {},
	netgrowData: {},
	netgrowList: [],
	netgrowPagination: {},
	downlineList: [],
	downlinePagination: {},
	errorValidation: []
});

const state = defaultState();

const getters = {
};

const mutations = {
	setGenealogyList(state, data) {
		state.genealogyList = data.results;
  },
	setSponsorList(state, data) {
		state.sponsorData = data
		state.sponsorList = data.results
		state.sponsorPagination = data.pagination
	},
	setNetgrowList(state, data) {
		state.netgrowData = data
		state.netgrowList = data.results
		state.netgrowPagination = data.pagination
	},
	setDownlineList(state, data) {
		state.downlineList = data.results
		state.downlinePagination = data.pagination
	},

	setErrorValidation(state, data) {
		state.errorValidation = data
	},
};

const actions = {
	getGenealogyList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.getGenealogyList(params).then((results) => {
				const data = results.data.data
				commit('setGenealogyList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	addRegistration({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.addRegistration(params).then((results) => {
				const data = results.data	
				dispatch('success', data, { root : true })
				resolve(data.data.results)
			}).catch((err) => {
				reject(true);
				// const { data } = err.response;
				// console.log('Err addRegistration', err.response)
				commit('setErrorValidation', err.response.data.data)
				reject(err.response.data.data)
				// dispatch('errorHandler', data, { root : true });
			});
		});
	},
	addCloneMitra({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.addCloneMitra(params).then((results) => {
				const data = results.data	
				dispatch('success', data, { root : true })
				resolve(data.data.results)
			}).catch((err) => {
				// console.log('Err addCloneMitra', err.response)
				// const { data } = err.response;
				// dispatch('errorHandler', err.response, { root : true });
				commit('setErrorValidation', err.response.data.data)
				reject(err.response.data.data);
			});
		});
	},
	addActivation({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.addActivation(params).then((results) => {
				const data = results.data	
				dispatch('success', data, { root : true })
				resolve(data.data.results)
			}).catch((err) => {
				reject(err.response.data.data);
				// const { data } = err.response;
				commit('setErrorValidation', err.response.data.data)
				// dispatch('errorHandler', data, { root : true });
			});
		});
	},
	addRepeatOrder({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.addRepeatOrder(params).then((results) => {
				const data = results.data	
				dispatch('success', data, { root : true })
				resolve(data.data.results)
			}).catch((err) => {
				reject(err.response.data.data);
				// const { data } = err.response;
				commit('setErrorValidation', err.response.data.data)
				// dispatch('errorHandler', data, { root : true });
			});
		});
	},
	addUpgrade({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.addUpgrade(params).then((results) => {
				const data = results.data	
				dispatch('success', data, { root : true })
				resolve(data.data.results)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getSponsorList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.getSponsorList(params).then((results) => {
				const data = results.data.data
				commit('setSponsorList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getNetgrowList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.getNetgrowList(params).then((results) => {
				const data = results.data.data
				commit('setNetgrowList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
			});
		});
	},
	getDownlineList({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiJaringan.getDownlineList(params).then((results) => {
				const data = results.data.data
				commit('setDownlineList', data)
				resolve(data)
			}).catch((err) => {
				reject(true);
				const { data } = err.response;
				dispatch('errorHandler', data, { root : true });
				commit('setErrorValidation', data)
			});
		});
	},

	errorHandler({ commit }, response) {
		// console.log('errorHandler', response)
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.data.error) {
				case 'validation':
					commit('setErrorValidation', response.data.data)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;

			}
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};